const SERVER_URL = "https://muddy-lake-1027.fly.dev";
// const SERVER_URL = 'http://localhost:3000';

export default SERVER_URL;
